<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Facility Settings-->
<div class="sp-Menu">
	<!--Heading-->
	<h4>Facility Settings:</h4>

	<!--Options Grid-->
	<div class="sp-OptionGrid">
		<label>Facility:</label>
		<select class="form-control" name="SelectedFacilityID" (ngModelChange)="onFacilityChange($event)" [(ngModel)]="SelectedFacilityID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstFacilities" [ngValue]="o.FacilityID">
				{{ o.FacilityName }}
			</option>
		</select>

		<label>Facility Location:</label>
		<select class="form-control" name="SelectedFacilityLocationID" [(ngModel)]="SelectedFacilityLocationID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstFacilityLocations" [ngValue]="o.FacilityLocationID">
				{{ o.FacilityLocationName }}
			</option>
		</select>

		<label>Normal Scan Sound:</label>
		<select class="form-control" name="NormalScanSound" [(ngModel)]="NormalScanSound">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstNormalSound" [ngValue]="o">
				{{ o.SoundFile }}
			</option>
		</select>

		<label>Invalid Scan Sound:</label>
		<select class="form-control" name="ErrorScanSound" [(ngModel)]="InvalidScanSound">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstInvalidSound" [ngValue]="o">
				{{ o.SoundFile }}
			</option>
		</select>
	</div>
</div>

<!--User Settings-->
<div class="sp-Menu">
	<!--Heading-->
	<h4>User Settings:</h4>

	<!--Options Grid-->
	<div class="sp-OptionGrid">
		<label>Asynchronous Scans:</label>
		<div>
			<input id="IsAsyncScan" [(ngModel)]="IsAsyncScan" type="checkbox" />
			<label for="IsAsyncScan">Allow more than 1 scan to be processed simultaneously</label>
		</div>

		<label>Receipt Printer:</label>
		<select class="form-control" name="SelectedPrinterID" [(ngModel)]="SelectedPrinterID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstPrinters" [ngValue]="o.IDPrinterID">
				{{ o.Name }}
			</option>
		</select>
	</div>
</div>

<!--Hall Pass Reason Maintenance-->
<div class="sp-Menu">
	<div>
		<h4>Hall Pass Reason Maintenance:</h4>
	</div>

	<div class="sp-Table">
		<h5>Hall Pass Reasons:</h5>

		<!--Menu Bar-->
		<div class="lock-to-top" style="background-color: #ffffff">
			<!--Buttons-->
			<div class="button-body flex">
				<button class="btn btn-primary" style="margin-left: 0px" (click)="onAdd()">Add Reason</button>
				<button class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Reason</button>
				<button class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">Delete Reason</button>
			</div>
		</div>

		<!--Table-->
		<div class="table-main-body">
			<p-table
				#mydt
				[value]="lstHallPassReasons"
				[paginator]="true"
				[(rows)]="pagerows"
				[(first)]="pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedReason"
				dataKey="ReasonID"
				(onFilter)="onHandleFilter($event)"
				(onSort)="onHandleSort($event)"
				(onRowSelect)="onRowSelect($event)"
				(onRowUnselect)="onRowUnselect($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[10, 25, 50]"
			>
				<!--Headers-->
				<ng-template pTemplate="header">
					<!--Filter or Select from Dropdown-->
					<tr>
						<th>
							<p-columnFilter type="text" field="ReasonDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>
						<th>
							<p-columnFilter field="Level" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterLevel
										[ngModel]="value"
										[options]="lstLevel"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>
						<th>
							<p-columnFilter field="DefinedBy" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterDefinedBy
										[ngModel]="value"
										[options]="lstDefinedBy"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>
					</tr>

					<!--Column Names-->
					<tr style="height: 4rem">
						<th pSortableColumn="ReasonDesc">Reason Description<p-sortIcon field="ReasonDesc"></p-sortIcon></th>
						<th pSortableColumn="Level">Level<p-sortIcon field="Level"></p-sortIcon></th>
						<th pSortableColumn="DefinedBy">Defined By<p-sortIcon field="DefinedBy"></p-sortIcon></th>
					</tr>
				</ng-template>

				<!--Data-->
				<ng-template pTemplate="body" let-reason>
					<tr [pSelectableRow]="reason">
						<td *ngFor="let col of cols" style="font-weight: bold">
							{{ reason[col.field] }}
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!--Error Message-->
		<div class="form-group sp-TopMargin">
			<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
				{{ errorMessage }}
			</div>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="sp-Buttons">
	<button class="btn btn-primary" (click)="onSave()">Save</button>
	<button class="btn btn-primary" (click)="onReset()">Reset</button>
</div>
